import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import Menubar from "../Menubar";
import { store } from "../../App"; import ShowAlert from "../alert"; import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable"; import jsPDF from "jspdf"; import { Row, Col, Button, Container } from 'react-bootstrap'; import {exportToExcel} from "../utils/commonFunctions"; import { Link } from "@mui/material";

const IndicatorBasedAchievements = () =>  {
  const [mainEnb, setMainEnb] = useState(false);const [Districtenb, setDistrictenb] = useState(false); const [searchText, setSearch] = useState(""); const [data, setData] = useState();
  const [searchText1, setSearch1] = useState("");const [districtlist, setDistrictList] = useState([]);  const [data1, setData1] = useState(); const [subenbmnd, setsubenbmnd] = useState(false);  const [Distnames, setDistnames] = useState([]); const [Mndnames, setMndnames] = useState([]);

  let role = localStorage.getItem("role");let user = localStorage.getItem("username");  let district = localStorage.getItem("districtid");

  const formik = useFormik({ initialValues: { district_id: "" }, })

  React.useEffect(() => { if ((role === "2") || (role === "10") || (role === "3")) { setDistrictenb(true); } if (role === "5") { setDistrictenb(false); } formik.setFieldValue("district_id", district !== "0" ? district : ""); }, [])

const fetchdata=(params)=>{
  store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getIndicatorwiseReport(params).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setData1(res.data.SDESC)
        const uniqueMndnames = [...new Set(res.data.SDESC.map(item => item.mandal_name))];
        setMndnames(uniqueMndnames); setMainEnb(false); setsubenbmnd(true);
      }
    }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
}
  useEffect(() => { MasterService.getDistricts().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistrictList(options); } }); if (role === "10" || role === "2") { let params = { "userId": user, "districtId": district }; fetchdata(params); } }, []);

const getsubdata = (district_id) => { formik.setFieldValue("district_id",district_id); let params1 = { "userId": user, "districtId": district_id, }; fetchdata(params1); }




  const getAdmindata = (e) => {
    formik.setFieldValue("district_id", e.target.value)
    if ((role === "5" || role === "8") && (e.target.value !== "" && e.target.value !== undefined)) {
      let params = { "districtId": e.target.value === "0" ? null : e.target.value, "userId": user, }
      if (e.target.value !== "0") { fetchdata(params); } 
      else if (e.target.value === "0") {
        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.getIndicatorwiseReport(params).then((res) => { if (res.data && res.data.SCODE === "01") { setData(res.data.SDESC); const uniqueDistnames = [...new Set(res.data.SDESC.map(item => item.district_name))]; setDistnames(uniqueDistnames); } setMainEnb(true); setsubenbmnd(false); }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
      }
    }
  }

  const getfilteredData = searchText.length > 0 ? data?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); }) ); }) : data;


  const getfilteredData1 = searchText1.length > 0 ? data1?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase())); }) ); }) : data1;
function getgeneratePdf(tableid) { const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [1500, 1500], }); autoTable(doc, { html: tableid, theme: "grid", tableWidth: 1000, columnStyles: { 3: { cellWidth: "wrap"} }, headStyles: { halign: "center" }, styles: { fontSize: 8 }, }); doc.save("Indicator Wise Achievements Report.pdf"); }

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "80%" }}>
        <div className='sa-title'> <h2>Indicatorwise Achievements <span>Report</span></h2> </div>
      </Container>

      <Container fluid style={{ width: "80%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

            <div className='mandal-container p-4 mt-2'>

              <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mx-4" > <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span> <Field component="select" name="district_id" disabled={Districtenb} className="form-control" value={formik.values.district_id} onChange={(e) => { getAdmindata(e) }} > <option value="">--Select--</option> <option value="0">All</option> {districtlist} </Field> <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span> </Col>

              </Row>
            </div>

          </Form>
        </FormikProvider><br />


        {mainEnb &&
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-3" > <div class="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div> <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch(event.target.value)} /> </div> </Col>

              <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={() => getgeneratePdf("#my-table")} style={{ float: "right", marginLeft: "3px" }}> PDF<MdOutlinePictureAsPdf /> </Button>
                <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Indicator Wise Achievements Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </Button>
              </Col>
            </Row>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
              <table
  id="my-table"
  className="table table-bordered custom-table table-responsive sticky-table"
>
  <thead>
    <tr>
      <th className="sticky-col sticky-sno">Sl.No.</th> <th className="sticky-col sticky-indicator">Sector Name</th> <th className="sticky-col sticky-subindicator">Indicator Name</th> <th className="sticky-col sticky-phase1unit">Unit</th>
      {Distnames.map((district1, index) => ( <th key={index}>{district1}</th> ))}
      <th>Totals</th>
    </tr>
  </thead>
  <tbody>
    {getfilteredData?.length === 0 || getfilteredData === undefined ? ( <tr> <td colSpan={Distnames.length + 4} className="text-center" style={{ color: "red" }}> Details Not Found </td> </tr> ) : (
      getfilteredData.reduce((acc, detail) => {
        const existingRow = acc.find(row => row.sub_indicator_name === detail.sub_indicator_name);

        if (!existingRow) {
          acc.push({ sub_indicator_id: detail.sub_indicator_id, indicator_name: detail.indicator_name, sub_indicator_name: detail.sub_indicator_name, unit: detail.unit, districtData: { [detail.district_name]: { achived: detail.achived, district_code: detail.district_code }, }, });
        } 
        else { existingRow.districtData[detail.district_name] = { achived: detail.achived, district_code: detail.district_code }; }

        return acc;
      }, []).map((row, index, array) => {
        const isFirstOccurrence = index === 0 || row.indicator_name !== array[index - 1].indicator_name;

        const totalAchived = Distnames.reduce((sum, district3) => {
          return sum + (row.districtData[district3]?.achived || 0);
        }, 0);

        const districtsWithAchived = Distnames.reduce((count, district3) => { return count + (row.districtData[district3]?.achived > 0 ? 1 : 0); }, 0);

        const customSubIndicatorIds = [26, 27, 24, 29, 21, 30, 25, 20, 28, 22, 23,120];
        const totalValue = customSubIndicatorIds.includes(row.sub_indicator_id) ? totalAchived / (districtsWithAchived || 1) : totalAchived;

        return (
          <tr key={index}>
            <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
            <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.indicator_name : ""}</td>
            <td style={{ minWidth: "200px", wordWrap: "break-word", whiteSpace: "normal", textAlign: "left" }} className="sticky-col sticky-subindicator">{row.sub_indicator_name}</td>
            <td style={{ textAlign: "center" }} className="sticky-col sticky-phase1unit">{row.unit}</td>

            {Distnames.map((district4, i) => ( <td key={i} style={{ textAlign: "right" }}> {row.districtData[district4] !== undefined && ( <Link onClick={() => getsubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }} > {row.districtData[district4].achived} </Link> )} </td> ))}

            <td style={{ textAlign: "right", fontWeight: "bold" }}> {totalValue.toFixed(2)} </td>
          </tr>
        );
      })
    )}
  </tbody>
</table>

              </div>
            </div>
          </>
        }



        {subenbmnd && <>
          <Row  >
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-2" style={{ marginLeft: "40px" }}>
              <div class="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch1(event.target.value)} />
              </div>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-center" >
              <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={() => getgeneratePdf("#my-table1")} style={{ float: "right", marginLeft: "3px" }}> PDF<MdOutlinePictureAsPdf /> </Button>
              <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "Indicator Wise Achievements Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </Button>
            </Col>

          </Row>
          <div id="table-scroll" className="table-scroll" >
            <div className="table-wrap">
              <table bordered hover id="my-table1" className="table table-bordered custom-table table-responsive sticky-table">
                <thead>
                  <tr>
                    <th className="sticky-col sticky-sno">Sl.No.</th> <th className="sticky-col sticky-indicator">Sector Name</th> <th className="sticky-col sticky-subindicator">Indicator Name</th> <th className="sticky-col sticky-phase1unit">Unit</th>
                    {Mndnames.map((mandal, index) => ( <th key={index}>{mandal}</th> ))}
                    <th>Totals</th>
                  </tr>
                  </thead>
                  <tbody>
  {getfilteredData1?.length === 0 || getfilteredData1 === undefined ? ( <tr> <td colSpan={Mndnames.length + 5} className="text-center" style={{ color: "red" }}> Details Not Found </td> </tr> ) : (
    getfilteredData1.reduce((acc, detail) => {
      const existingRow = acc.find(row => row.sub_indicator_name === detail.sub_indicator_name);

      if (!existingRow) { acc.push({ sub_indicator_id: detail.sub_indicator_id, indicator_name: detail.indicator_name, sub_indicator_name: detail.sub_indicator_name, unit: detail.unit, mandalData: { [detail.mandal_name]: { achived: detail.achived, mandal_code: detail.mandal_code, }, }, }); } 
      else { existingRow.mandalData[detail.mandal_name] = { achived: detail.achived, mandal_code: detail.mandal_code, }; }

      return acc;
    }, []).map((row, index, array) => {
      const isFirstOccurrence = index === 0 || row.indicator_name !== array[index - 1].indicator_name;

      const totalAchived = Mndnames.reduce((sum, mandal) => { return sum + (row.mandalData[mandal]?.achived || 0); }, 0);

      const specialSubIndicators = [26, 27, 24, 29, 21, 30, 25, 20, 28, 22, 23,120];

      const mandalsWithAchieved = Mndnames.filter(mandal => row.mandalData[mandal]?.achived > 0).length;

      const adjustedTotal = specialSubIndicators.includes(row.sub_indicator_id) ? totalAchived / (mandalsWithAchieved || 1) : totalAchived;

      return (
        <tr key={index}>
          <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
          <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.indicator_name : ""}</td>
          <td style={{ minWidth: "200px", wordWrap: "break-word", whiteSpace: "normal", textAlign: "left" }} className="sticky-col sticky-subindicator">{row.sub_indicator_name}</td>
          <td style={{ textAlign: "center" }} className="sticky-col sticky-phase1unit">{row.unit}</td>
          {Mndnames.map((mandal, i) => ( <td key={i} style={{ textAlign: "right" }}> {row.mandalData[mandal]?.achived && ( row.mandalData[mandal].achived )} </td> ))}
          <td style={{ textAlign: "right", fontWeight: "bold" }}> {adjustedTotal.toFixed(2)} </td>
        </tr>
      );
    })
  )}
</tbody>

              </table>
            </div>

          </div>
        </>

        }
      </Container>
    </>
  );
};
export default IndicatorBasedAchievements;